/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicGovernanceInstanceStatus extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicGovernanceInstanceStatus");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicGovernanceInstanceStatus.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicGovernanceInstanceStatus>): BackgroundJobPayloadForPeriodicGovernanceInstanceStatus {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicGovernanceInstanceStatus(), model);
        BackgroundJobPayloadForPeriodicGovernanceInstanceStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicGovernanceInstanceStatus>): BackgroundJobPayloadForPeriodicGovernanceInstanceStatus {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicGovernanceInstanceStatus.newInstance(<BackgroundJobPayloadForPeriodicGovernanceInstanceStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicGovernanceInstanceStatus) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicGovernanceInstanceStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicGovernanceInstanceStatus): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicGovernanceInstanceStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
